import { RSAA } from 'redux-api-middleware';
import { userAccountIsAuthenticatedSelector as isAuthenticatedSelector } from '../selectors/isAuthenticated';
import { LOGOUT } from './types';

const requestApiAction = () => ({
  [RSAA]: {
    endpoint: '/v1/auth/logout',
    method: 'POST',
    credentials: 'include',
    types: [LOGOUT.REQUEST, LOGOUT.SUCCESS, LOGOUT.FAILURE],
  },
});

export const userAccountLogoutThunkAction = (params) => async (dispatch, getState) => {
  const isAuthenticated = isAuthenticatedSelector(getState());

  if (isAuthenticated) {
    await dispatch(requestApiAction(params));
  }
};
